export function buildContentSheetAttachmentsPayload(attachments, overrides) {
  return attachments.map((item) => ({
    attachment: {
      fileId: item.fileId,
      contentId: Number(item.contentId),
      typeId: item.attachmentTypeId ?? 0,
      version: item.version ?? 0,
      ...(overrides?.attachment ?? {}),
    },
    deliveryControl: {
      revisionReason: item.revisionReason ?? null,
      completionDates: {
        channelNotes: item.channelNotes ?? null,
        productionAssessment: item.productionAssessment ?? null,
        contentAssessment: item.contentAssessment ?? null,
        diversityAssessment: item.diversityAssessment ?? null,
        received: item.receivedAt,
      },
    },
  }));
}

export function buildMaterialPlanningAttachmentPayload(attachment) {
  const revisionId = parseInt(attachment.reason ?? attachment.revisionId, 10);

  return {
    contentId: attachment.contentId,
    received: attachment.receivedAt,
    fileId: attachment.fileId,
    ...(revisionId ? { revisionId } : {}),
  };
}

export function buildChapterPlanningAttachmentPayload(attachment) {
  return {
    version: attachment.version,
    fileId: attachment.fileId,
    attachmentTypeId: attachment.attachmentTypeId,
    received: attachment.receivedAt,
  };
}

export function buildReleasePayload({
  contentId,
  releases = [],
  unreleases = [],
}) {
  return {
    contentId,
    releases: releases.map(
      ({ attachmentId, releaseType, observation = "" }) => ({
        attachmentId,
        releaseType,
        observation,
      })
    ),
    unreleases: unreleases.map(
      ({ attachmentId, releaseType, observation = "" }) => ({
        attachmentId,
        releaseType,
        observation,
      })
    ),
  };
}

export function buildBatchReleasePayload({
  contentId,
  releases = [],
  unreleases = [],
}) {
  return {
    contentId,
    releases: releases.map(
      ({ attachmentId, releaseType, observation = "" }) => ({
        releaseType,
        attachmentId,
        observation,
      })
    ),
    unreleases: unreleases.map(
      ({ attachmentId, releaseType, observation = "" }) => ({
        releaseType,
        attachmentId,
        observation,
      })
    ),
  };
}

export function buildEditContentAttachmentPayload(attachment) {
  return {
    typeId: attachment.attachmentTypeId,
    version: attachment.version,
    receivedAt: attachment.receivedAt,
  };
}

export function buildEditMaterialPlanningAttachmentPayload(attachment) {
  const revisionId = attachment.reason ? parseInt(attachment.reason, 10) : null;

  return {
    updateDeliveryControl: {
      channelNotes: attachment.channelNotes ?? null,
      productionAssessment: attachment.productionAssessment ?? null,
      contentAssessment: attachment.contentAssessment ?? null,
      diversityAssessment: attachment.diversityAssessment ?? null,
      received: attachment.receivedAt ?? null,
    },
    newMaterialId: attachment.newMaterialId ?? null,
    ...(revisionId ? { revisionId } : {}),
  };
}

export function buildEditBlockChapterPlanningAttachmentPayload(attachment) {
  return {
    newChapterId: attachment.chapterId,
    newBlockId: attachment.blockId,
    version: attachment.version,
    deliveryControl: {
      channelNotes: attachment.channelNotes ?? null,
      productionAssessment: attachment.productionAssessment ?? null,
      contentAssessment: attachment.contentAssessment ?? null,
      diversityAssessment: attachment.diversityAssessment ?? null,
      received: attachment.receivedAt ?? null,
    },
  };
}
